module.exports = __webpack_public_path__ + "static/gold-logo-97cb7a8adaede6cf297285eed25f3a0d.svg";